module.exports = __webpack_public_path__ + "static/media/jetson_one_render_17.42f60354.jpg";